<template>
  <rys-thd-modal-wrapper
    class="embed-modal"
    @hide="$emit('hide', $event)"
  >
    <!-- Conditionally render the embed or the form -->
    <div
      v-if="!showForm"
      class="embed"
      :style="{ paddingBottom: `${ratio * 100}%` }"
      v-html="embed"
    />
    <div v-else class="form-layout">
      <!-- New: Image on the left -->
      <img
        v-if="formImage"
        :src="formImage"
        alt="Form Image"
        class="form-image"
      >
      <!-- Form and text content on the right -->
      <div class="form-content-wrapper">
        <!-- Render formContent above the form, only if it exists -->
        <div
          v-if="formContent"
          class="form-content"
          v-html="formContent"
        />
        <RysStayConnectedForm />
        <!-- Render disclaimer below the form, only if it exists -->
        <div
          v-if="disclaimer"
          class="form-disclaimer"
          v-html="disclaimer"
        />
      </div>
    </div>
  </rys-thd-modal-wrapper>
</template>

<script>
import RysStayConnectedForm from '@/components/StayConnectedForm.vue';

export default {
  name: 'RysEmbedModal',

  components: {
    RysStayConnectedForm
  },

  props: {
    embed: { type: String, required: false },
    ratio: { type: Number, default: 9 / 16 },
    showForm: { type: Boolean, default: false },
    formContent: { type: String, required: false },
    disclaimer: { type: String, required: false },
    formImage: { type: String, required: false }
  }
};
</script>

<style lang="scss" scoped>
.embed-modal {
  width: calc(100vw - 32px);
  max-height: 592px;
  overflow: auto;

  @media screen and (min-width: $breakpoint-md) {
    width: 960px;
  }

  @media screen and (min-width: $breakpoint-sm) {
    max-height: none;
  }

  .embed::v-deep {
    width: 100%;
    height: 0;
    overflow: hidden;
    position: relative;

    iframe {
      width: 100% !important;
      height: 100% !important;
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  .form-layout {
    display: flex;

    @media (min-width: $breakpoint-sm) {
      justify-content: center;
    }

    img {
      display: none;
      object-fit: cover;
      width: 50%;

      @media (min-width: $breakpoint-sm) {
        display: block;
      }
    }

    .form-content-wrapper {
      margin: 34px 28px;

      .form-content {
        text-align: center;

        &::v-deep h2 {
          font-size: 28px;
          line-height: 36px;
          text-transform: uppercase;
          margin-top: 0;
        }

        &::v-deep p {
          line-height: 24px;
        }
      }
    }

    .form-disclaimer {
      font-size: 11px;
      line-height: 18px;
      color: #706060;
    }
  }
}
</style>
